/// send a data layer event to google analytics whenever the search bar is used
(function ($) {
    $('#evo-search-form').submit(function () {
        window.dataLayerManager.push({
            event: 'Main Search',
            searchTerm: $('#txt-search').val()
        })
    });
})(jQuery);